<template>
	<div
		class="nice-modal"
		:id="'lightBoxMob-review-'+index"
	>
		<span
			class="reviewmodalclose"
			@click.prevent="closeModal"
			data-test="reviewMobileModalCloseSpan"
			id="reviewMobileModalCloseSpan"
		>
			<i class="fas fa-times"
						data-test="reviewMobileModalCloseIcon"
						id="reviewMobileModalCloseIcon"></i>
		</span>
		<div class="image-wrapper">
			<image-slider
				:imageArray="review.image_urls"
				:initialSlide="imageSelected"
				v-if="showSlider"
			>
			</image-slider>
		</div>
		<div class="wp_bgColorWhite">
			<div class="wp_riviewRightSideContainer">
				<div
					class="wp_userRatingStarConatiner"
					:id="'review-rating-'"
				>
					<div class="wp_userRiviewPoint"
										data-test="reviewMobileModalRating"
										id="reviewMobileModalRating">
						{{review.rating}}
					</div>
					<svg
								xmlns:xlink="http://www.w3.org/1999/xlink"
								class="wp_RatingStarFill"
								version="1.1"
								id="Layer_1"
								xmlns="http://www.w3.org/2000/svg"
								x="0px"
								y="0px"
								viewBox="0 0 512 512"
								enable-background="new 0 0 512 512"
								xml:space="preserve"
								data-test="reviewMobileModalRatingSvg"
						>
							<polygon points="255.999,19.827 314.622,200.247 504.327,
							200.247 350.853,311.754 409.472,492.174 255.999,
							380.668 102.525,492.174 161.146,
							311.754 7.673,200.247 197.378,200.247 "></polygon>
					</svg>
				</div>
				<h5
					class="wp_ReviewCaptionH5"
					:id="'review-title-'"
					data-test="reviewMobileModalReviewTitle"
				>
					{{review.review_title}}
				</h5>
				<!--<small>Updated 12.01.2018</small>-->
			</div>
			<div class="col-12 pr-0 mr-0 p-0">
				<p
					:id="'review-text-'+index"
					class="pl-3 pr-3 review-text"
					data-test="reviewMobileModalReviewText"
				>
					{{review.review_text}}
				</p>
			</div>
			<div class="col-12 pr-0 mr-0">
				<div class="wp_riviewRightSideContainer p-0">
					<review-footer
						:review="review"
						:productId="productId"
						:index="index"
						@commentReview="commentReview($event)"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ReviewFooter from '@/components/pages/productDetails/sections/ReviewFooter'
import ImageSlider from '@/components/pages/productDetails/widgets/ImageSlider'
export default {
	name: 'mobile-review-nice-modal',
	props: {
		review: {},
		productId: null,
		index: {
			default: 0,
			type: Number
		},
		imageSelected: {
			default: 0,
			type: Number
		}
	},
	components: {
		ReviewFooter,
		ImageSlider
	},
	data () {
		return {
			showSlider: true
		}
	},
	methods: {
		closeModal (e) {
			this.showSlider = false
			this.$emit('closeMobileReviewModal', e)
		},
		commentReview (comment) {
			this.$emit('commentReview', comment)
		}
	}
}
</script>

<style scoped>

</style>
